import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOfflineInstalledProductsByIdsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input'];
}>;


export type GetOfflineInstalledProductsByIdsQuery = { __typename?: 'query_root', installed_products: Array<{ __typename?: 'installed_products', id: any, status_last_updated_at?: any | null }> };


export const GetOfflineInstalledProductsByIdsDocument = gql`
    query getOfflineInstalledProductsByIds($ids: [uuid!]!) {
  installed_products(
    where: {id: {_in: $ids}, device_status: {_eq: "offline"}, status_last_updated_at: {_is_null: false}, deleted_at: {_is_null: true}}
  ) {
    id
    status_last_updated_at
  }
}
    `;

/**
 * __useGetOfflineInstalledProductsByIdsQuery__
 *
 * To run a query within a React component, call `useGetOfflineInstalledProductsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfflineInstalledProductsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfflineInstalledProductsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetOfflineInstalledProductsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables> & ({ variables: GetOfflineInstalledProductsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables>(GetOfflineInstalledProductsByIdsDocument, options);
      }
export function useGetOfflineInstalledProductsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables>(GetOfflineInstalledProductsByIdsDocument, options);
        }
export function useGetOfflineInstalledProductsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables>(GetOfflineInstalledProductsByIdsDocument, options);
        }
export type GetOfflineInstalledProductsByIdsQueryHookResult = ReturnType<typeof useGetOfflineInstalledProductsByIdsQuery>;
export type GetOfflineInstalledProductsByIdsLazyQueryHookResult = ReturnType<typeof useGetOfflineInstalledProductsByIdsLazyQuery>;
export type GetOfflineInstalledProductsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetOfflineInstalledProductsByIdsSuspenseQuery>;
export type GetOfflineInstalledProductsByIdsQueryResult = Apollo.QueryResult<GetOfflineInstalledProductsByIdsQuery, GetOfflineInstalledProductsByIdsQueryVariables>;